import { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import NotFoundPage from '../pages/not-found/not-found-page';
import { LoadingScreen } from '@bemap/ui';
import { RoleLevel, useRouteGuard } from '@bemap/utils';
import PartnerRoutes from './partner-routes';
import AnalystRoutes from './analyst-routes';
import PublicRoutes from './public-routes';

const App: FC = () => {
  const { isAuthenticated, user, isLoading } = useRouteGuard();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isAuthenticated && user?.permission === RoleLevel.PARTNER) {
    return (
      <Routes>
        <Route path="/*" element={<PartnerRoutes user={user} />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    );
  }

  if (isAuthenticated && user?.permission === RoleLevel.ANALYST) {
    return (
      <Routes>
        <Route path="/*" element={<AnalystRoutes user={user} />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/*" element={<PublicRoutes />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default App; 